import { replaceSpaceDash } from './stringutils';
import { get } from './objectHelper';

// Pass in array of coordintes
// examples geoJSONMarkerHelper([ [-61.2158203125, -15.97189158092897], [12,12] ])
export function geoJSONMarkerHelper(arr){
    var tempArr = [];
    for(var i=0; i < arr.length; i++){
       tempArr.push({
        "type": "Feature",
        "properties": {
            "pointClass": arr[i].pointClass,
            "name":arr[i].name,
            "textClass":arr[i].textClass,
            "duration":arr[i].duration,
            "id":arr[i].id
        },
        "geometry": {"type": "Point","coordinates": arr[i].coordinates}
       });

       if(tempArr.length === arr.length){
           return {"id":"markersItem", "type": "FeatureCollection","features":tempArr};
       }
    }
}


//Convert list of coordinates into point format
export function pointConverterHelper(arr){
    var tempArr = [];
    for(var i = 0; i < arr.length; i++){
        var pt = {
          "type": "Feature",
          "properties": {},
          "geometry": {
            "type": "Point",
            "coordinates": arr[i]
          }
        }
        tempArr.push(pt);
    }
    return tempArr;
}


export function featurePointConverterHelper(arr){
    var tempArr = [];
    for(var i = 0; i < arr.length; i++){
        tempArr.push({
          "type": "Feature",
          "properties": {},
          "geometry": {
            "type": "Point",
            "coordinates": arr[i]
          }
        });
    }
    return {"type": "FeatureCollection","features":tempArr};
}


//Midpoint helper - pass in array of coordinates, return midpoints
// export function midPointerHelper(arr){
//     var tempArr = [];
//     for(var i = 0; i < arr.length; i++){
//         if(i < arr.length - 1){
//             var midpoint = turf.midpoint(arr[i], arr[i+1]);
//             tempArr.push(midpoint.geometry.coordinates);
//         }
//     }
//     return tempArr;
// }


//Bearing helper - pass in array of coordinates, return bearing
// export function bearingHelper(arr){
//     var tempArr = [];
//     for(var i = 0; i < arr.length; i++){
//         if(i < arr.length - 1){
//             var bearing = turf.bearing(arr[i], arr[i+1]);
//             tempArr.push(bearing);
//         }
//     }
//     return tempArr;
// }



// ResultsExtraHelper
//  - adds extra data to the external loaded JSON;
//  - converts lat long into array format
//  - add on randomise properties for the flyover
export function resultsExtraHelper(arr){

    var _tempArr = [];

    for(var i = 0; i < arr.length; i++){
 
        //show cities (no products)
        if(arr[i].type === 'start' || arr[i].type === 'city' || arr[i].type === 'product'){

            //check for empty coordinates
            if(arr[i].cityInfo === undefined && arr[i].cityInfo.pickUpDropOff){
                console.warn('Incorrect coordinates - Please check your coordinates are not 0,0');
                return;
            }

            //replace spaces with dash
            arr[i].name = (arr[i].type === 'start' || arr[i].type === 'city') ? replaceSpaceDash(arr[i].to) : replaceSpaceDash(arr[i].name);


        
            var sectorOrProduct = (arr[i].type === 'start' || arr[i].type === 'city') ? get([i, "cityInfo", "pickUpDropOff"], arr, arr[i].cityInfo.location) : arr[i].cityInfo.location;
            var tempCoordinates = [parseFloat(sectorOrProduct.lon), parseFloat(sectorOrProduct.lat)];


            arr[i].pointClass = "marker circleoutline ";
            arr[i].pointClass += (arr[i].type === "start" || arr[i].type === "city") ? "sector " : "product ";
            arr[i].textClass = "city-text top";
            arr[i].coordinates = tempCoordinates;
            arr[i].duration = (i === 0) ? "" : (arr[i].nights || 0);

            _tempArr.push(arr[i]);
        }
       
    }
    return _tempArr;
    
}


//Show points only
// - will show only points and NO LINES
export function showPointOnly(tourID, arr){
    for(var i=0; i < arr.length; i++){
        if(arr[i] === tourID){
            return true;
        }
    }
}
